// extracted by mini-css-extract-plugin
export var integrationButton = "_9y-0";